import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { apis as api } from "../../../services/api.action";
import { connect, useDispatch } from "react-redux";
import Main from "../../layouts/Main";
import ContentTop from "../../ui-setup/ContentTop";
import { cnt } from "../../../services/constant.action";
import { BOM } from "../../../services/defined.action";
import appLabel from "../../../config/appLabel";
import { Link } from "react-router-dom";
import RecordStatus from "../../ui-setup/RecordStatus";

const CoBankDetail = (props) => {

  const { location, userData, configData, recordData, menuData } = props;
  const { state } = location;
  const { profileId, session, companyId } = userData;
  const { isCsd } = configData;

  const dispatch = useDispatch();
  const [coBankDetail, setCoBankDetail] = useState({});

  useEffect(() => {
    // console.log(state.ggParam);
    
    getDetailById(state.ggParam);
  }, []);

  const getDetailById = (params) => {
    // console.log(params);

    BOM.LoadAlert(cnt.LOAD, "Processing");

    let body = {
      profileId,
      compBankId: params.BANK_ID,
      companyId:params.COMPANY_ID,
      session,
    };

    // /** FETCH ROLE */
    BOM.FetchReqAction(body, api.GetCompanyBank, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        let coBankDetail = res.companyBankDetail;

        setCoBankDetail(coBankDetail);
        dispatch({
          type: cnt.RECORD_STATUS,
          payload: coBankDetail,
        });
        //handle right side
        BOM.IsApproveOrReject(coBankDetail.FLG_STATUS, menuData, "Manage Company Bank");
      }
    });
  };

  const onApprove = () => {
    let bodyApprove = {
      profileId,
      compBankId: state.ggParam.BANK_ID,
      companyId: state.ggParam.COMPANY_ID,
      criteria: "A",
      session,
    };

    // console.log(bodyApprove);
    BOM.GlobalApproveRejectAction(
      bodyApprove,
      api.ApproveRejectCompanyBank,
      "manage-company-bank",
      "Company Bank",
      "Approve "
    );
  }
  const onReject = () => {
    let bodyDisable = {
      profileId,
      compBankId: state.ggParam.BANK_ID,
      companyId: state.ggParam.COMPANY_ID,
      criteria: "R",
      session,
    };

    // console.log(bodyDisable);
    BOM.GlobalApproveRejectAction(
      bodyDisable,
      api.ApproveRejectCompanyBank,
      "manage-company-bank",
      "Company Bank",
      "Reject "
    );
  }
  
  return (
   <Main {...props} onApprove={onApprove} onReject={onReject}>
      <ContentTop pageTitle={appLabel.coBankDetail} />
      <div className="animated fadeInRight">
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>{appLabel.coBankInfo}</h5>
                <div className="ibox-tools">
                  <Link to="/manage-company-bank" className="btn btn-primary btn-xs">
                    <i className="fa fa-arrow-circle-left" />
                    &nbsp;
                    {appLabel.backBtn}
                  </Link>
                </div>
              </div>
              <div className="ibox-content contentCard panel-primary">
                <div className="row">
                <div className="col-sm-12">
                      <label className="al-heading">
                        <i className="fa fa-circle-o text-navy"></i>&nbsp;{" "}
                        {appLabel.generalInfo}
                      </label>
                      <div
                        className="hr-line-dashed"
                        style={{ marginTop: 0 }}
                      />
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.bankId}&nbsp;
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.BANK_ID}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.companyName}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.COMPANY_NAME}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.bankName}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.BANK_NAME}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.accountNumber}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.ACC_NUM}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.accountName}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.ACC_NAME}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle ">
                            {appLabel.branchCode}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.BRANCH_CODE}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.accountType}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.ACC_TYPE}
                            disabled
                          />
                        </div>
                      </div>
                      {/* <div className="row form-group col-md-6">
                        <div className="col-md-4 text-left">
                          <label className="al-subtitle">
                            {appLabel.nuban}{" "}
                            
                          </label>
                        </div>
                        <div className="col-md-7">
                        <input
                            type="text"
                            className="form-control input-sm"
                            defaultValue={coBankDetail.NUBAN}
                            disabled
                          />
                        </div>
                      </div> */}
                      
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <RecordStatus {...recordData} />
      </div>
    </Main>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  menuData: state.staticData.menuData,
  configData: state.auth.configData,
  recordData: state.recordStatus
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CoBankDetail);
